import React from "react";
import s from "./Buzon.module.css";
import MailList from "./MailList";
import Write from "./Write"
import { Grid, Tabs, Tab, Container } from "@mui/material";

const Buzon = () => {
  
  const [tabValue, setTabValue] = React.useState(0);
  
  return (
    <> 
    <Container >
      <Grid container spacing={2} >
        <Grid item xs={12} className={s.tabContainer}>
          <Tabs value={tabValue} onChange={(event, newValue) => setTabValue(newValue)}>
            <Tab label="Buzón" />
            <Tab label="Redactar" />
          </Tabs>
        </Grid>
      </Grid>
      <Grid item xs={12} className={s.render}>
        {
          tabValue === 0 && <MailList /> /* : tabValue === 1 ? <SentItems /> : <Trash /> */
        }
        {
          tabValue === 1 && <Write /> 
        }
      </Grid>

    </Container>
    </>
  );
};

export default Buzon;